<div [style.height.px]="chartHeight()">
    <canvas baseChart [data]="placeholderChartConfiguration.data" [options]="placeholderChartConfiguration.options"></canvas>
</div>
